<div
  class="container-pie w-100 h-100 d-flex flex-column p-3"
>
  <!-- Titre et bouton déplacer alignés en haut avec espacement -->
  <div class="d-flex align-items-center justify-content-between w-100 mb-3">
    <div class="fw-bold text-truncate text-start flex-grow-1">
      {{ title }}
    </div>
    <i class="bi bi-arrows-fullscreen text-primary" style="cursor: move;"></i>
  </div>

  <!-- Contenu du graphique centré dans l'espace restant -->
  <div class="flex-grow-1 d-flex align-items-center justify-content-center">
    @if (hasChartData) {
      <div class="d-flex flex-column align-items-center justify-content-center w-100">
        <div class="chart-wrapper-small">
          <canvas
            baseChart
            [data]="pieChartData"
            [type]="pieChartType"
            [options]="pieChartOptions"
          ></canvas>
        </div>

        <div class="total-display text-center mt-2">
          <div class="small text-muted">Total des dossiers</div>
          <div class="fw-bold fs-5">{{ getTotalValue() }}</div>
        </div>
      </div>
    } @else {
      <div class="text-muted text-center w-100">
        <i class="fas fa-chart-pie fa-2x mb-2"></i>
        <div>Aucune donnée à afficher</div>
      </div>
    }
  </div>
</div>

<!-- HTML Tooltip -->
<div id="chart-tooltip" class="custom-tooltip" hidden>
  <div class="tooltip-content"></div>
</div>
